const convertDateTimeToAmpm = (dateObj, fullYear = false) => {
  const monthNames = [
    'Jan',
    'Feb',
    'Mar',
    'Apr',
    'May',
    'June',
    'July',
    'Aug',
    'Sept',
    'Oct',
    'Nov',
    'Dec',
  ];
  let day = dateObj.getDate();
  if (day <= 9) day = `0${day}`;
  const month = monthNames[dateObj.getMonth()];
  const year = fullYear
    ? dateObj.getFullYear().toString()
    : dateObj.getFullYear().toString().substr(-2);
  let hours = dateObj.getHours();
  let dateObjMinutes = dateObj.getMinutes();
  const ampm = hours >= 12 ? 'pm' : 'am';
  hours %= 12;
  hours = hours || 12;
  dateObjMinutes = dateObjMinutes < 10 ? `0${dateObjMinutes}` : dateObjMinutes;
  const timeString = `${hours}:${dateObjMinutes} ${ampm}`;
  const dateString = `${day} ${month} ${year}`;
  const displayString = `${dateString}, ${timeString}`;
  return displayString;
};
export default convertDateTimeToAmpm;
